import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center font-mono-rm" data-testid="auth-loading">
        Checking the cave...
      </div>
    );
  }
  if (!user) {
    // Remember where they were headed (e.g. /exit-survey from the wrap-up
    // email) so Login can bounce them straight back after auth.
    try {
      const path = window.location.pathname + window.location.search;
      if (path && path !== "/login") sessionStorage.setItem("resmo:postAuthNext", path);
    } catch { /* sessionStorage blocked */ }
    return <Navigate to="/login" replace />;
  }
  // NDA enforcement lives in App.js <NdaGate> — it walls every route
  // (public pages included) for signed-in users who still owe a signature.
  return children;
}
